export class UserData {
    public role: string;
    public username: string;
}

export class TestingDataForPost {
    public gridelementid: number;
    public x: number;
    public y: number;

    constructor(gridelementid: number, x: number, y: number) {
        this.gridelementid = gridelementid;
        this.x = x;
        this.y = y;
    }
}